import '@fontsource/inter/latin.css';
import Alpine from 'alpinejs';

window.Alpine = Alpine

Alpine.start()